import {Action} from '@ngrx/store';
import {DatabaseNotification} from '@app/core/models/databaseNotification.model';
import {INotificationNumbers} from '@app/core/services/auth.service';

export enum ENotificationsActions {
	GetLatestNotifications = '[Notifications] Get Notifications',
	GetLatestNotificationsSuccess = '[Notifications] Get Notifications Success',

	SetNotifications = '[Notifications] Set notifications',

	GetNotificationNumbers = '[Notifications] Get Notification Numbers',
	GetNotificationNumbersSuccess = '[Notifications] Get Notification Numbers Success',

	SetNotificationNumbers = '[Notifications] Set notification numbers',

	MarkAllNotificationsAsRead = '[Notifications] Mark all notifications as read',
	MarkAllNotificationsAsReadSuccess = '[Notifications] Mark all notifications as read success',

	MarkConversationAsRead = '[Notifications] Mark conversation as read',
	MarkConversationAsReadSuccess = '[Notifications] Mark conversation as read success',

	MarkNotificationAsRead = '[Notifications] Mark notification as read',
	SetShowNotifications = '[Notifications] Set Show Notifications',
}

export class GetLatestNotifications implements Action {
	public readonly type = ENotificationsActions.GetLatestNotifications;

	constructor() {
	}
}

export class GetLatestNotificationsSuccess implements Action {
	public readonly type = ENotificationsActions.GetLatestNotificationsSuccess;

	constructor(public notifications: DatabaseNotification[]) {
	}
}

export class SetNotifications implements Action {
	public readonly type = ENotificationsActions.SetNotifications;

	constructor(public notifications: DatabaseNotification[]) {
	}
}

export class GetNotificationNumbers implements Action {
	public readonly type = ENotificationsActions.GetNotificationNumbers;

	constructor() {
	}
}

export class GetNotificationNumbersSuccess implements Action {
	public readonly type = ENotificationsActions.GetNotificationNumbersSuccess;

	constructor(public notificationNumbers: INotificationNumbers) {
	}
}

export class SetNotificationNumbers implements Action {
	public readonly type = ENotificationsActions.SetNotificationNumbers;

	constructor(public notificationNumbers: INotificationNumbers) {
	}
}

export class MarkAllNotificationsAsRead implements Action {
	public readonly type = ENotificationsActions.MarkAllNotificationsAsRead;

	constructor() {
	}
}

export class MarkAllNotificationsAsReadSuccess implements Action {
	public readonly type = ENotificationsActions.MarkAllNotificationsAsReadSuccess;

	constructor() {
	}
}

export class MarkConversationAsRead implements Action {
	public readonly type = ENotificationsActions.MarkConversationAsRead;

	constructor(public conversationId: number) {
	}
}

export class MarkConversationAsReadSuccess implements Action {
	public readonly type = ENotificationsActions.MarkConversationAsReadSuccess;

	constructor(public conversationId: number) {
	}
}

export class MarkNotificationAsRead implements Action {
	public readonly type = ENotificationsActions.MarkNotificationAsRead;

	constructor(public notification: DatabaseNotification) {
	}
}

export class SetShowNotifications implements Action {
	public readonly type = ENotificationsActions.SetShowNotifications;

	constructor(public show: boolean) {
	}
}

export type NotificationsActions =
	GetLatestNotifications |
	GetLatestNotificationsSuccess |
	SetNotifications |
	GetNotificationNumbers |
	GetNotificationNumbersSuccess |
	SetNotificationNumbers |
	MarkAllNotificationsAsRead |
	MarkAllNotificationsAsReadSuccess |
	MarkConversationAsRead |
	MarkConversationAsReadSuccess |
	MarkNotificationAsRead |
	SetShowNotifications
	;
